import React from 'react';
import { IconProps } from '.';

const SvgScreenZoomIn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.25 10.25h-5.5v-1.5h2.94L3.97 5.03l-.53-.53L4.5 3.44l.53.53 3.72 3.72V4.75h1.5v5.5Zm8.25 0h.75v-1.5h-2.94l3.72-3.72.53-.53-1.06-1.06-.53.53-3.72 3.72V4.75h-1.5v5.5h4.75Zm1 10.31-.53-.53-3.72-3.72v2.94h-1.5v-5.5h.75v.69-.69H19.25v1.5H16.31l3.72 3.72.53.53-1.06 1.06ZM3.44 19.5l.53-.53 3.72-3.72H4.75v-1.5h5.5v5.5h-1.5v-2.94l-3.72 3.72-.53.53-1.06-1.06Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgScreenZoomIn;
